import { Component, OnInit, Input } from '@angular/core';
import {Router,NavigationEnd } from '@angular/router'

@Component({
  selector: 'app-top-bar-layout',
  templateUrl: './top-bar-layout.component.html',
  styleUrls: ['./top-bar-layout.component.css']
})
export class TopBarLayoutComponent implements OnInit {

  merchantDetails:any
  @Input('sidenav') sidenav;
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.merchantDetails = JSON.parse(localStorage.getItem('merchantDetails'))
  }
  
  logout(){
    localStorage.clear();
    this.router.navigateByUrl('/signin');
  }

}
